import { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';

// Components
import EducationSlider from './formationAndExperience/EducationSlider';
import TextToEdit from './formationAndExperience/TextToEdit';

const FormationAndExperience = () => {
    const divRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        if (divRef.current) {
            const divWidth = divRef.current.getBoundingClientRect().width;
            setContainerWidth(divWidth);
        }
    }, []);

    return (
        <Container ref={divRef}>
            <h4>Educación en ADEN</h4>
            <EducationSlider width={containerWidth} />
            <TextToEdit
                label="Educación en otras instituciones"
                property={{
                    formatted: 'academicTraining',
                    notFormatted: 'academic_training',
                }}
                setFieldValue={() => {}}
            />
            <TextToEdit
                label="Experiencia laboral"
                property={{
                    formatted: 'workExperience',
                    notFormatted: 'experience',
                }}
                setFieldValue={() => {}}
            />
        </Container>
    );
};

export default FormationAndExperience;

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;
